<template>
    <div>
        
        <div class="interiorTab m-1" v-if="usuarios.length<=0">
            <CRow>
                <CCol sm="12" md="12" lg="12">
                    <center>No hay usuarios creados para este cliente</center>
                </CCol>
            </CRow>
        </div>
        <div class="interiorTab m-1" v-else>
            {{ infoCliente }}
            <DatosGeneralClientes :datosGeneral="infoCliente" :mostrarUsuarios="true" :mostrarApps="true" />
            <CRow>
                <CCol>
                    <CDropdown color="drpdwn-menu" size="sm">
                        <template #toggler-content>
                            <CIcon :content="$options.freeSet.cilApplications" />
                            Acciones
                        </template>
                        <div role="group">
                            <CDropdownItem>
                                Cerrar Sesión Usuarios
                            </CDropdownItem>
                            <CDropdownItem @click="accionesCliente.verCerrarApps = !accionesCliente.verCerrarApps">
                                Cerrar Aplicaciones Usuarios
                            </CDropdownItem>
                        </div>
                    </CDropdown>
                </CCol>
                <CCol>
                    <CButton
                        size="sm"
                        class="btn-class mb-1">
                        Cerrar Sesión Usuarios
                    </CButton>
                </CCol>
                <CCol>
                    <CButton
                        size="sm"
                        class="btn-class mb-1"
                        @click="accionesCliente.verCerrarApps = !accionesCliente.verCerrarApps">
                        Cerrar Aplicación Usuario
                    </CButton>
                    <CButtonGroup v-show="accionesCliente.verCerrarApps"
                        class="mb-1">
                        <CButton color="secondary" size="sm" class=" ml-1">
                            App abierta x
                        </CButton>
                        <CButton color="secondary" size="sm" class=" ml-1">
                            App abierta y
                        </CButton>
                        <CButton color="secondary" size="sm" class=" ml-1">
                            App abierta z
                        </CButton>
                    </CButtonGroup>
                </CCol>
            </CRow>
            <CRow class="mt-1">
                <CCol sm="12" md="12" lg="12"
                    v-bind:key="usuario.infoUsuario.idUsuario"
                    v-for="(usuario, i) in filtrarUsuarios(usuarios)">
                    <CCard class="mt-1 mb-1" :class="(usuario.infoUsuario.habilitado)?'cardHabil':'cardDeshab'"
                        @mouseover="usuario.acciones.focus = true" 
                        @mouseout="usuario.acciones.focus = false">
                        <CCardHeader>
                            <div class="card-header-actions" v-show="usuario.acciones.focus">
                                <CLink class="card-header-action btn-minimize" @click="usuario.acciones.mostrarMas = !usuario.acciones.mostrarMas">
                                    <CIcon v-show="usuario.acciones.mostrarMas" :content="$options.freeSet.cilChevronTop" />
                                    <CIcon v-show="!usuario.acciones.mostrarMas" :content="$options.freeSet.cilChevronBottom" />
                                </CLink>
                            </div>
                            <CRow>
                                <CCol col="3" class="infoDetalle">
                                    <div><span class="font-weight-bold">Usuario Vapp: </span> {{ usuario.infoUsuario.username }}</div>
                                    <!--<div><span class="font-weight-bold">Nombre: </span> {{ usuario.nombreUsuario }} {{  usuario.apellidoPat}} {{ usuario.apellidoMat }}</div>-->
                                    <div><span class="font-weight-bold">Mail: </span><span> {{ usuario.infoUsuario.mailUsuario }}</span> </div>
                                    <div><span class="font-weight-bold">Tipo Usuario: </span> {{ usuario.infoUsuario.usuarioAdmin ? 'Admin' : 'Normal' }}</div>
                                </CCol>
                                <CCol col="2">
                                    <div><span class="font-weight-bold">Creado: </span> {{ $utils.formatearFecha(usuario.infoUsuario.fechaCreacionUsuario) }}</div>
                                    <div><span class="font-weight-bold">Expira: </span> {{ $utils.formatearFecha(usuario.infoUsuario.fechaExpiracionUsuario) }}</div>

                                    <!--<div>
                                        <span class="font-weight-bold">Habilitado: </span>
                                        <CIcon style="color:green" name="cil-check-circle" v-show="usuario.habilitado"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!usuario.habilitado" />
                                    </div>-->
                                    
                                </CCol>
                                <CCol col="3">                          
                                    <CRow>
                                        <span class="font-weight-bold">Apps: </span>
                                        <span v-bind:key="appUsuario.idApp" v-for="(appUsuario, i) in usuario.apps">
                                            <span
                                                :class="(appUsuario.habilitado)?'appHab':'appDesHab'"
                                                :content="getMensajeInfoApps(appUsuario)"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >{{ appUsuario.nombreCortoApp }}{{(i<(usuario.apps.length-1)?'|':'' )}}</span>
                                        </span>
                                    </CRow>
                                    <!--<CRow>
                                        <CCol>
                                            <span class="font-weight-bold">Agregada/Expira</span> ({{ $utils.formatearFecha(appUsuario.fechaAsignacion) }})/({{ $utils.formatearFecha(appUsuario.fechaExpiracion) }})
                                        </CCol>
                                    </CRow>-->
                                    <!--<CRow>
                                        <CCol>
                                            <span class="font-weight-bold">Habilitado: </span> 
                                            <CIcon style="color:green" name="cil-check-circle" v-show="appUsuario.habilitado"/>
                                            <CIcon style="color:red" name="cil-x-circle" v-show="!appUsuario.habilitado" />
                                        </CCol>
                                    </CRow>
                                    -->
                                </CCol>
                                <CCol col="2" v-if="usuario.registrosSesion != null">
                                    <div><span class="font-weight-bold">Último Inicio: </span> 
                                        {{ $utils.formatearFecha(usuario.registrosSesion.ultimoInicio.registro_inicio) }}
                                    </div>
                                    <div><span class="font-weight-bold">Último Fin Sesion: </span> 
                                        {{ $utils.formatearFecha(usuario.registrosSesion.ultimoInicio.registro_termino) }}
                                    </div>
                                    
                                </CCol>
                                <CCol>
                                    <CDropdown color="drpdwn-menu" size="sm" v-show="usuario.acciones.focus">
                                        <template #toggler-content>
                                            <CIcon :content="$options.freeSet.cilApplications" />
                                            Acciones Usuario
                                        </template>
                                        <div role="group">
                                            <CDropdownItem>
                                                {{(usuario.infoUsuario.habilitado)?'Deshabilitar':'Habilitar'}}
                                            </CDropdownItem>
                                            <CDropdownItem>
                                                Desbloquear(si el usuario esta bloqueado, validar para mostrar)
                                            </CDropdownItem>
                                            <CDropdownItem>
                                                Cerrar Sesión (Validar si está iniciada para mostrar opcion)
                                            </CDropdownItem>
                                        </div>
                                    </CDropdown>
                                </CCol>
                            </CRow>
                        </CCardHeader>
                        <CCollapse :show="usuario.acciones.mostrarMas" :duration="400">
                            <CCardBody style="background-color: #F5F5F5;">
                                <CTabs :active-tab.sync="actTab">
                                    <CTab>
                                        <template slot="title">
                                            Información Usuario
                                        </template>
                                        <InfoUsuario :informacionUsuario="usuario.infoUsuario" />
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                        </CCollapse>
                    </CCard>
                </CCol>
            </CRow>
        </div>
        
    </div>
</template>

<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";

    import Multiselect from "vue-multiselect";

    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import { freeSet } from "@coreui/icons";

    //import moment from 'moment'
    import { format, formatDistance, formatRelative, isThisISOWeek, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    
    //import UsuariosClienteVapp from "./UsuariosClienteVapp";
    import DatosGeneralClientes from './DatosGeneralClientes'
    import InfoUsuario from './InfoUsuario'

    //import DatePicker from 'vue2-datepicker';
    //import 'vue2-datepicker/index.css';
    

    import Pagination from 'vue-pagination-2';

    export default {
        name: "UsuariosCliente",
        freeSet,
        props:{
            usuarios: Array,
            accionesCliente: Object,
            infoCliente: Object
        },
        components: {
            Multiselect,
            Modal: VueModal,
            Pagination,
            DatosGeneralClientes,
            InfoUsuario,
        },
        data() {
            return {

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,

                actTab: 0,
                
            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            filtrarUsuarios: function(usuarios){
                return this.$vs.getSearch(usuarios, '')
            },
            getMensajeInfoApps: function(appUsuario){
                /*
                <CIcon style="color:green" name="cil-check-circle" v-show="appUsuario.habilitado"/>
                                            <CIcon style="color:red" name="cil-x-circle" v-show="!appUsuario.habilitado" />
                */
                let iconoHabilitado = (appUsuario.habilitado)?'Si':'No'
                return `<div>Habilitada: ${iconoHabilitado}</div>
                <div>Agregada: (${this.$utils.formatearFecha(appUsuario.fechaAsignacion)})</div>
                <div>Expira: (${this.$utils.formatearFecha(appUsuario.fechaExpiracion)})</div>`
            }


        },
    };
</script>

<style>
.appHab{
    color:green;
}
.appDesHab{
    color: red;
}
.cardHabil{
    border-color: green;
}
.cardDeshab{
    border-color: red;
}

</style>